import { InjectionToken } from '@angular/core';

import { ModalViewConfig } from '../models';

export const MODAL_VIEW_CONFIG = new InjectionToken<ModalViewConfig>('ModelViewConfig');
